goog.provide("shadow.js.shim.module$dayjs$locale$da");
goog.provide("module$shadow_js_shim_module$dayjs$locale$da");
shadow.js.shim.module$dayjs$locale$da = shadow.js.nativeProvides["dayjs/locale/da"] = require("dayjs/locale/da");
module$shadow_js_shim_module$dayjs$locale$da.default = shadow.js.shim.module$dayjs$locale$da;
